"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'hap' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 2 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'hap' });
    }
    ;
    /**
    * @typedef {Object} revisionsRestorePopupCancelParams
    * @property {GUID} i1 - null
    * @property {string} popup_type - adi to editor, editor to adi, regular restore
    * @property {number} c2 - null
    * @property {string} revision_builder - adi, editor
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) restore popup cancel. Evid: 254.
    
    
     * i1 - Type: guid.
     *
     * popup_type - Type: string. Desc: adi to editor, editor to adi, regular restore
     *
     * c2 - Type: numeric.
     *
     * revision_builder - Type: string. Desc: adi, editor
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsRestorePopupCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsRestorePopupCancel = function (params) {
        return this.bi.log(__assign({ evid: 254 }, params));
    };
    /**
    * @typedef {Object} revisionsRevisionViewSuccessParams
    * @property {number} loadTime - time elapsed from click
    * @property {GUID} i1 - msid
    * @property {number} c2 - referrer
    * @property {string} revision_builder - adi, editor
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - revision
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - site
    * @property {string} version - app version
    **/
    /**
     * Name: (revisions) revision view success. Evid: 267.
     * Event description: view revision success.
    
     * loadTime - Type: numeric. Desc: time elapsed from click
     *
     * i1 - Type: guid. Desc: msid
     *
     * c2 - Type: numeric. Desc: referrer
     *
     * revision_builder - Type: string. Desc: adi, editor
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric. Desc: revision
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid. Desc: site
     *
     * version - Type: string. Desc: app version
     * @param {revisionsRevisionViewSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsRevisionViewSuccess = function (params) {
        return this.bi.log(__assign({ evid: 267 }, params));
    };
    /**
    * @typedef {Object} myAccountSpecialOffersParams
    * @property {string} g1 - null
    * @property {GUID} c1 - null
    **/
    /**
     * Name: my account -> special offers. Evid: 135.
    
    
     * g1 - Type: string.
     *
     * c1 - Type: guid.
     * @param {myAccountSpecialOffersParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountSpecialOffers = function (params) {
        return this.bi.log(__assign({ evid: 135 }, params));
    };
    /**
    * @typedef {Object} myAccountTransferTransferParams
    
    **/
    /**
     * Name: my account -> transfer -> transfer. Evid: 95.
    
    
    
     * @param {myAccountTransferTransferParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountTransferTransfer = function (params) {
        return this.bi.log(__assign({ evid: 95 }, params));
    };
    /**
    * @typedef {Object} myAccountPersonalizedUpgradeBannerPerMetasiteParams
    * @property {string} g1 - null
    * @property {number} i1 - null
    * @property {GUID} c1 - null
    **/
    /**
     * Name: my account -> personalized upgrade banner per metasite. Evid: 83.
    
    
     * g1 - Type: string.
     *
     * i1 - Type: numeric.
     *
     * c1 - Type: guid.
     * @param {myAccountPersonalizedUpgradeBannerPerMetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountPersonalizedUpgradeBannerPerMetasite = function (params) {
        return this.bi.log(__assign({ evid: 83 }, params));
    };
    /**
    * @typedef {Object} myAccountDeleteSitePopupCanceledClickedParams
    
    **/
    /**
     * Name: my account -> Delete site popup Canceled clicked. Evid: 76.
    
    
    
     * @param {myAccountDeleteSitePopupCanceledClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountDeleteSitePopupCanceledClicked = function (params) {
        return this.bi.log(__assign({ evid: 76 }, params));
    };
    /**
    * @typedef {Object} myAccountEditGmailLinkParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: (my account) edit gmail link. Evid: 145.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountEditGmailLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountEditGmailLink = function (params) {
        return this.bi.log(__assign({ evid: 145 }, params));
    };
    /**
    * @typedef {Object} myAccountLimitedTimeOfferBoxParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> limited time offer box. Evid: 144.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountLimitedTimeOfferBoxParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountLimitedTimeOfferBox = function (params) {
        return this.bi.log(__assign({ evid: 144 }, params));
    };
    /**
    * @typedef {Object} myAccountTransferBackParams
    
    **/
    /**
     * Name: my account -> transfer -> back. Evid: 94.
    
    
    
     * @param {myAccountTransferBackParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountTransferBack = function (params) {
        return this.bi.log(__assign({ evid: 94 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnFooterBannerParams
    
    **/
    /**
     * Name: my account -> click on footer banner. Evid: 125.
    
    
    
     * @param {myAccountClickOnFooterBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnFooterBanner = function (params) {
        return this.bi.log(__assign({ evid: 125 }, params));
    };
    /**
    * @typedef {Object} myAccountUserClickOnBreadcrumbElementParams
    * @property {string} c1 - null
    **/
    /**
     * Name: (my account) user click on breadcrumb element. Evid: 155.
    
    
     * c1 - Type: string.
     * @param {myAccountUserClickOnBreadcrumbElementParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUserClickOnBreadcrumbElement = function (params) {
        return this.bi.log(__assign({ evid: 155 }, params));
    };
    /**
    * @typedef {Object} dashboardSiteViewCreateNewSiteParams
    
    **/
    /**
     * Name: dashboard site view -> create new site. Evid: 161.
    
    
    
     * @param {dashboardSiteViewCreateNewSiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSiteViewCreateNewSite = function (params) {
        return this.bi.log(__assign({ evid: 161 }, params));
    };
    /**
    * @typedef {Object} revisionsFilterInRevisionPageParams
    * @property {string} filter_type - published, starred, all
    * @property {GUID} i1 - msid
    * @property {number} c2 - referrer
    * @property {number} g1 - revision
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - site id
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) filter in revision page. Evid: 269.
     * Event description: any kind of filter.
    
     * filter_type - Type: string. Desc: published, starred, all
     *
     * i1 - Type: guid. Desc: msid
     *
     * c2 - Type: numeric. Desc: referrer
     *
     * g1 - Type: numeric. Desc: revision
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid. Desc: site id
     *
     * version - Type: string. Desc: version
     * @param {revisionsFilterInRevisionPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsFilterInRevisionPage = function (params) {
        return this.bi.log(__assign({ evid: 269 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnRenameMetasiteParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> click on rename metasite. Evid: 81.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountClickOnRenameMetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnRenameMetasite = function (params) {
        return this.bi.log(__assign({ evid: 81 }, params));
    };
    /**
    * @typedef {Object} revisionsRestoreRevisionSuccessParams
    * @property {number} loadTime - time elapsed from click
    * @property {GUID} i1 - msid
    * @property {number} c2 - referrer
    * @property {string} revision_builder - adi, editor
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - revision
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - site id
    * @property {boolean} switch_builder - true if restoring to a different builder
    * @property {string} version - app version
    **/
    /**
     * Name: (revisions) restore revision success. Evid: 268.
     * Event description: revision restore success.
    
     * loadTime - Type: numeric. Desc: time elapsed from click
     *
     * i1 - Type: guid. Desc: msid
     *
     * c2 - Type: numeric. Desc: referrer
     *
     * revision_builder - Type: string. Desc: adi, editor
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric. Desc: revision
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid. Desc: site id
     *
     * switch_builder - Type: bool. Desc: true if restoring to a different builder
     *
     * version - Type: string. Desc: app version
     * @param {revisionsRestoreRevisionSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsRestoreRevisionSuccess = function (params) {
        return this.bi.log(__assign({ evid: 268 }, params));
    };
    /**
    * @typedef {Object} siteMembersSignupReuestsSectionClickedParams
    
    **/
    /**
     * Name: (site members) signup reuests section clicked. Evid: 206.
    
    
    
     * @param {siteMembersSignupReuestsSectionClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersSignupReuestsSectionClicked = function (params) {
        return this.bi.log(__assign({ evid: 206 }, params));
    };
    /**
    * @typedef {Object} myAccountSiteActionsViewMoreParams
    
    **/
    /**
     * Name: my account -> site actions 'view more'. Evid: 89.
    
    
    
     * @param {myAccountSiteActionsViewMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountSiteActionsViewMore = function (params) {
        return this.bi.log(__assign({ evid: 89 }, params));
    };
    /**
    * @typedef {Object} myAccountCreateSiteBottomOfFirstPageParams
    
    **/
    /**
     * Name: my account -> create site bottom of first page. Evid: 123.
    
    
    
     * @param {myAccountCreateSiteBottomOfFirstPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountCreateSiteBottomOfFirstPage = function (params) {
        return this.bi.log(__assign({ evid: 123 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnMobileSupportCenterParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> click on 'mobile support center'. Evid: 143.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountClickOnMobileSupportCenterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnMobileSupportCenter = function (params) {
        return this.bi.log(__assign({ evid: 143 }, params));
    };
    /**
    * @typedef {Object} revisionsPageStartParams
    * @property {GUID} i1 - null
    * @property {number} c2 -  0- dash, 1 - editor
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {number} g1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) page start. Evid: 250.
    
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric. Desc:  0- dash, 1 - editor
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * g1 - Type: numeric.
     *
     * version - Type: string. Desc: version
     * @param {revisionsPageStartParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsPageStart = function (params) {
        return this.bi.log(__assign({ evid: 250 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnDeleteMobileParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> click on 'delete mobile'. Evid: 142.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountClickOnDeleteMobileParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnDeleteMobile = function (params) {
        return this.bi.log(__assign({ evid: 142 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnConnectDomainParams
    * @property {GUID} c1 - null
    **/
    /**
     * Name: my account -> click on connect domain. Evid: 84.
    
    
     * c1 - Type: guid.
     * @param {myAccountClickOnConnectDomainParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnConnectDomain = function (params) {
        return this.bi.log(__assign({ evid: 84 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnBackToMyAccountParams
    
    **/
    /**
     * Name: my account -> click on 'back to my account'. Evid: 138.
    
    
    
     * @param {myAccountClickOnBackToMyAccountParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnBackToMyAccount = function (params) {
        return this.bi.log(__assign({ evid: 138 }, params));
    };
    /**
    * @typedef {Object} revisionsRestoreSuccessGoToEditorParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) restore success go to editor. Evid: 256.
    
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsRestoreSuccessGoToEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsRestoreSuccessGoToEditor = function (params) {
        return this.bi.log(__assign({ evid: 256 }, params));
    };
    /**
    * @typedef {Object} siteMembersDialogClosedWithDoneParams
    
    **/
    /**
     * Name: (site members) dialog closed with Done. Evid: 202.
    
    
    
     * @param {siteMembersDialogClosedWithDoneParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersDialogClosedWithDone = function (params) {
        return this.bi.log(__assign({ evid: 202 }, params));
    };
    /**
    * @typedef {Object} dashboardLoadedParams
    * @property {boolean} c1 - null
    * @property {string} i1 -
    * @property {number} g1 - null
    **/
    /**
     * Name: dashboard -> loaded. Evid: 302.
    
    
     * c1 - Type: bool.
     *
     * i1 - Type: string.
     *
     * g1 - Type: numeric.
     * @param {dashboardLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardLoaded = function (params) {
        return this.bi.log(__assign({ evid: 302 }, params));
    };
    /**
    * @typedef {Object} myAccountUserClicksDuplicateButtonParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: (my account) user clicks 'duplicate button'. Evid: 149.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUserClicksDuplicateButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUserClicksDuplicateButton = function (params) {
        return this.bi.log(__assign({ evid: 149 }, params));
    };
    /**
    * @typedef {Object} siteMembersDialogClosedWithXParams
    
    **/
    /**
     * Name: (site members) dialog closed with X. Evid: 201.
    
    
    
     * @param {siteMembersDialogClosedWithXParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersDialogClosedWithX = function (params) {
        return this.bi.log(__assign({ evid: 201 }, params));
    };
    /**
    * @typedef {Object} revisionsRestoreClickParams
    * @property {GUID} i1 - null
    * @property {string} popup_type - adi to editor, editor to adi, regular restore
    * @property {number} c2 - null
    * @property {string} revision_builder - adi, editor
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) restore click. Evid: 253.
    
    
     * i1 - Type: guid.
     *
     * popup_type - Type: string. Desc: adi to editor, editor to adi, regular restore
     *
     * c2 - Type: numeric.
     *
     * revision_builder - Type: string. Desc: adi, editor
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsRestoreClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsRestoreClick = function (params) {
        return this.bi.log(__assign({ evid: 253 }, params));
    };
    /**
    * @typedef {Object} myAccountSiteActionsViewLessParams
    
    **/
    /**
     * Name: my account -> site actions 'view less'. Evid: 90.
    
    
    
     * @param {myAccountSiteActionsViewLessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountSiteActionsViewLess = function (params) {
        return this.bi.log(__assign({ evid: 90 }, params));
    };
    /**
    * @typedef {Object} myAccountGoPremiumButtonParams
    
    **/
    /**
     * Name: my account -> Go premium button. Evid: 13.
    
    
    
     * @param {myAccountGoPremiumButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountGoPremiumButton = function (params) {
        return this.bi.log(__assign({ evid: 13 }, params));
    };
    /**
    * @typedef {Object} myAccountManageStoreLinkParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> manage store link. Evid: 97.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountManageStoreLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountManageStoreLink = function (params) {
        return this.bi.log(__assign({ evid: 97 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsSocialNetworkDisconnectFailedParams
    * @property {string} c1 - null
    **/
    /**
     * Name: dashboard settigs -> social_network_disconnect_failed. Evid: 175.
    
    
     * c1 - Type: string.
     * @param {dashboardSettigsSocialNetworkDisconnectFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsSocialNetworkDisconnectFailed = function (params) {
        return this.bi.log(__assign({ evid: 175 }, params));
    };
    /**
    * @typedef {Object} siteMembersMembersTabClickedParams
    
    **/
    /**
     * Name: (site members) members tab clicked. Evid: 203.
    
    
    
     * @param {siteMembersMembersTabClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersMembersTabClicked = function (params) {
        return this.bi.log(__assign({ evid: 203 }, params));
    };
    /**
    * @typedef {Object} myAccountTransferNextParams
    
    **/
    /**
     * Name: my account -> transfer -> next. Evid: 93.
    
    
    
     * @param {myAccountTransferNextParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountTransferNext = function (params) {
        return this.bi.log(__assign({ evid: 93 }, params));
    };
    /**
    * @typedef {Object} manageEtpaUserClicksDeleteButton157Params
    * @property {GUID} g1 -  etpa id
    * @property {GUID} c1 - null
    **/
    /**
     * Name: (manage etpa) user clicks delete button. Evid: 157.
    
    
     * g1 - Type: guid. Desc:  etpa id
     *
     * c1 - Type: guid.
     * @param {manageEtpaUserClicksDeleteButton157Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageEtpaUserClicksDeleteButton157 = function (params) {
        return this.bi.log(__assign({ evid: 157 }, params));
    };
    /**
    * @typedef {Object} myAccountDeletePopupOpenedParams
    
    **/
    /**
     * Name: my account -> Delete popup opened. Evid: 74.
    
    
    
     * @param {myAccountDeletePopupOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountDeletePopupOpened = function (params) {
        return this.bi.log(__assign({ evid: 74 }, params));
    };
    /**
    * @typedef {Object} myAccountSettingsButtonParams
    
    **/
    /**
     * Name: my account -> Settings button. Evid: 66.
    
    
    
     * @param {myAccountSettingsButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountSettingsButton = function (params) {
        return this.bi.log(__assign({ evid: 66 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnBannerParams
    * @property {string} c1 - null
    **/
    /**
     * Name: my account -> click on banner. Evid: 77.
    
    
     * c1 - Type: string.
     * @param {myAccountClickOnBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnBanner = function (params) {
        return this.bi.log(__assign({ evid: 77 }, params));
    };
    /**
    * @typedef {Object} biTestEventParams
    * @property {string} another_ran_test - another ran test description
    * @property {string} ran_test - ran test description
    **/
    /**
     * Name: bi test event. Evid: 45.
     * Event description: test events for BI.
    
     * another_ran_test - Type: string. Desc: another ran test description
     *
     * ran_test - Type: string. Desc: ran test description
     * @param {biTestEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.biTestEvent = function (params) {
        return this.bi.log(__assign({ evid: 45 }, params));
    };
    /**
    * @typedef {Object} myAccountTransferCloseParams
    * @property {string} origin - null
    **/
    /**
     * Name: my account -> transfer -> close. Evid: 92.
    
    
     * origin - Type: string.
     * @param {myAccountTransferCloseParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountTransferClose = function (params) {
        return this.bi.log(__assign({ evid: 92 }, params));
    };
    /**
    * @typedef {Object} myAccountOpeningMembersAreaManagerParams
    * @property {GUID} c1 - null
    **/
    /**
     * Name: my account -> opening members area manager. Evid: 87.
    
    
     * c1 - Type: guid.
     * @param {myAccountOpeningMembersAreaManagerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountOpeningMembersAreaManager = function (params) {
        return this.bi.log(__assign({ evid: 87 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsListSocialConnectionsFailedParams
    
    **/
    /**
     * Name: dashboard settigs -> list_social_connections_failed. Evid: 168.
    
    
    
     * @param {dashboardSettigsListSocialConnectionsFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsListSocialConnectionsFailed = function (params) {
        return this.bi.log(__assign({ evid: 168 }, params));
    };
    /**
    * @typedef {Object} myAccountViewSiteParams
    
    **/
    /**
     * Name: my account -> View site. Evid: 72.
    
    
    
     * @param {myAccountViewSiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountViewSite = function (params) {
        return this.bi.log(__assign({ evid: 72 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnAutoredirectMobileParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> click on 'autoredirect mobile'. Evid: 141.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountClickOnAutoredirectMobileParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnAutoredirectMobile = function (params) {
        return this.bi.log(__assign({ evid: 141 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsSocialNetworkDisconnectClickedParams
    * @property {string} c1 - null
    **/
    /**
     * Name: dashboard settigs -> social_network_disconnect_clicked. Evid: 171.
    
    
     * c1 - Type: string.
     * @param {dashboardSettigsSocialNetworkDisconnectClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsSocialNetworkDisconnectClicked = function (params) {
        return this.bi.log(__assign({ evid: 171 }, params));
    };
    /**
    * @typedef {Object} revisionsViewClickParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {string} revision_builder - adi , editor
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) view click. Evid: 252.
     * Event description: view revision click.
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * revision_builder - Type: string. Desc: adi , editor
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsViewClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsViewClick = function (params) {
        return this.bi.log(__assign({ evid: 252 }, params));
    };
    /**
    * @typedef {Object} myAccountCreateSiteTopOfSecondPageIncaseThereIsNoMetasiteParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> create site top of second page incase there is no metasite. Evid: 124.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountCreateSiteTopOfSecondPageIncaseThereIsNoMetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountCreateSiteTopOfSecondPageIncaseThereIsNoMetasite = function (params) {
        return this.bi.log(__assign({ evid: 124 }, params));
    };
    /**
    * @typedef {Object} manageEtpaUserClicksUpgradeParams
    * @property {GUID} g1 -  etpa id
    * @property {GUID} c1 - null
    **/
    /**
     * Name: (manage etpa) user clicks upgrade. Evid: 151.
    
    
     * g1 - Type: guid. Desc:  etpa id
     *
     * c1 - Type: guid.
     * @param {manageEtpaUserClicksUpgradeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageEtpaUserClicksUpgrade = function (params) {
        return this.bi.log(__assign({ evid: 151 }, params));
    };
    /**
    * @typedef {Object} dashboardMetasiteLoadingParams
    * @property {boolean} c1 - null
    * @property {string} i1 - null
    * @property {number} g1 - null
    **/
    /**
     * Name: dashboard -> metasite loading. Evid: 303.
    
    
     * c1 - Type: bool.
     *
     * i1 - Type: string.
     *
     * g1 - Type: numeric.
     * @param {dashboardMetasiteLoadingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardMetasiteLoading = function (params) {
        return this.bi.log(__assign({ evid: 303 }, params));
    };
    /**
    * @typedef {Object} myAccountConnectYourDomainSecondPageParams
    * @property {GUID} c1 - null
    **/
    /**
     * Name: my account -> connect your domain second page. Evid: 127.
    
    
     * c1 - Type: guid.
     * @param {myAccountConnectYourDomainSecondPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountConnectYourDomainSecondPage = function (params) {
        return this.bi.log(__assign({ evid: 127 }, params));
    };
    /**
    * @typedef {Object} dashboardMobilePromoteBannerParams
    
    **/
    /**
     * Name: dashboard -> mobile promote banner. Evid: 166.
    
    
    
     * @param {dashboardMobilePromoteBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardMobilePromoteBanner = function (params) {
        return this.bi.log(__assign({ evid: 166 }, params));
    };
    /**
    * @typedef {Object} myAccountUpgradeButtonClickedOnSecondPageOnSingleMetasiteParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> upgrade button clicked on second page on single metasite. Evid: 122.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUpgradeButtonClickedOnSecondPageOnSingleMetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUpgradeButtonClickedOnSecondPageOnSingleMetasite = function (params) {
        return this.bi.log(__assign({ evid: 122 }, params));
    };
    /**
    * @typedef {Object} duplicateDialogConfirmParams
    * @property {string} i1 - null
    **/
    /**
     * Name: duplicate dialog -> confirm. Evid: 160.
    
    
     * i1 - Type: string.
     * @param {duplicateDialogConfirmParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.duplicateDialogConfirm = function (params) {
        return this.bi.log(__assign({ evid: 160 }, params));
    };
    /**
    * @typedef {Object} myAccountManageAndEditSiteParams
    
    **/
    /**
     * Name: my account -> manage and edit site. Evid: 128.
    
    
    
     * @param {myAccountManageAndEditSiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountManageAndEditSite = function (params) {
        return this.bi.log(__assign({ evid: 128 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsListSocialConnectionsSentParams
    
    **/
    /**
     * Name: dashboard settigs -> list_social_connections_sent. Evid: 167.
    
    
    
     * @param {dashboardSettigsListSocialConnectionsSentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsListSocialConnectionsSent = function (params) {
        return this.bi.log(__assign({ evid: 167 }, params));
    };
    /**
    * @typedef {Object} dashboardLoadingParams
    * @property {boolean} c1 - null
    * @property {string} i1 - null
    * @property {number} g1 - null
    **/
    /**
     * Name: dashboard -> loading. Evid: 300.
    
    
     * c1 - Type: bool.
     *
     * i1 - Type: string.
     *
     * g1 - Type: numeric.
     * @param {dashboardLoadingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardLoading = function (params) {
        return this.bi.log(__assign({ evid: 300 }, params));
    };
    /**
    * @typedef {Object} myAccountTransferSiteParams
    
    **/
    /**
     * Name: my account -> transfer site. Evid: 91.
    
    
    
     * @param {myAccountTransferSiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountTransferSite = function (params) {
        return this.bi.log(__assign({ evid: 91 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnSiteLinkParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> click on site link. Evid: 139.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountClickOnSiteLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnSiteLink = function (params) {
        return this.bi.log(__assign({ evid: 139 }, params));
    };
    /**
    * @typedef {Object} revisionsFilterOnlyPublishedRevisionsEvent269IsReplacingThisEventParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {number} g1 - null
    * @property {GUID} c1 - null
    **/
    /**
     * Name: (revisions) filter only published revisions - event 269 is replacing this event. Evid: 260.
    
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * g1 - Type: numeric.
     *
     * c1 - Type: guid.
     * @param {revisionsFilterOnlyPublishedRevisionsEvent269IsReplacingThisEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsFilterOnlyPublishedRevisionsEvent269IsReplacingThisEvent = function (params) {
        return this.bi.log(__assign({ evid: 260 }, params));
    };
    /**
    * @typedef {Object} myAccountUserClicksOkInDuplicateDialogParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: (my account) user clicks ok in 'duplicate dialog'. Evid: 150.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUserClicksOkInDuplicateDialogParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUserClicksOkInDuplicateDialog = function (params) {
        return this.bi.log(__assign({ evid: 150 }, params));
    };
    /**
    * @typedef {Object} myAccountDeleteSitePopupOkClickedParams
    
    **/
    /**
     * Name: my account -> Delete site popup OK clicked. Evid: 75.
    
    
    
     * @param {myAccountDeleteSitePopupOkClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountDeleteSitePopupOkClicked = function (params) {
        return this.bi.log(__assign({ evid: 75 }, params));
    };
    /**
    * @typedef {Object} revisionsFlagRevisionParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {string} revision_builder - adi, editor
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) flag revision. Evid: 265.
     * Event description: star a revision.
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * revision_builder - Type: string. Desc: adi, editor
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsFlagRevisionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsFlagRevision = function (params) {
        return this.bi.log(__assign({ evid: 265 }, params));
    };
    /**
    * @typedef {Object} myAccountClickAnywhereInTheFooterParams
    
    **/
    /**
     * Name: my account -> click anywhere in the footer. Evid: 137.
    
    
    
     * @param {myAccountClickAnywhereInTheFooterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickAnywhereInTheFooter = function (params) {
        return this.bi.log(__assign({ evid: 137 }, params));
    };
    /**
    * @typedef {Object} revisionsMaximizeSidebarParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) maximize sidebar. Evid: 264.
    
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsMaximizeSidebarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsMaximizeSidebar = function (params) {
        return this.bi.log(__assign({ evid: 264 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsSocialNetworkConnectSuccessParams
    * @property {string} c1 - null
    **/
    /**
     * Name: dashboard settigs -> social_network_connect_success. Evid: 176.
    
    
     * c1 - Type: string.
     * @param {dashboardSettigsSocialNetworkConnectSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsSocialNetworkConnectSuccess = function (params) {
        return this.bi.log(__assign({ evid: 176 }, params));
    };
    /**
    * @typedef {Object} dashboardMainPageTopBannerParams
    
    **/
    /**
     * Name: dashboard -> main page top banner. Evid: 163.
    
    
    
     * @param {dashboardMainPageTopBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardMainPageTopBanner = function (params) {
        return this.bi.log(__assign({ evid: 163 }, params));
    };
    /**
    * @typedef {Object} myAccountUpgradeButtonPerMetasiteParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> Upgrade button per metasite. Evid: 119.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUpgradeButtonPerMetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUpgradeButtonPerMetasite = function (params) {
        return this.bi.log(__assign({ evid: 119 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsSocialNetworkConnectFailedParams
    * @property {string} error_message - error message
    * @property {string} c1 - null
    **/
    /**
     * Name: dashboard settigs -> social_network_connect_failed. Evid: 174.
    
    
     * error_message - Type: string. Desc: error message
     *
     * c1 - Type: string.
     * @param {dashboardSettigsSocialNetworkConnectFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsSocialNetworkConnectFailed = function (params) {
        return this.bi.log(__assign({ evid: 174 }, params));
    };
    /**
    * @typedef {Object} myAccountUserClicksToAddAnAppOnInsideThatIframeAndThatAppOpensEditorParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> user clicks to add an app on inside that iframe and that app opens editor. Evid: 132.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUserClicksToAddAnAppOnInsideThatIframeAndThatAppOpensEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUserClicksToAddAnAppOnInsideThatIframeAndThatAppOpensEditor = function (params) {
        return this.bi.log(__assign({ evid: 132 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsSocialNetworkDisconnectSuccessParams
    * @property {string} c1 - null
    **/
    /**
     * Name: dashboard settigs -> social_network_disconnect_success. Evid: 177.
    
    
     * c1 - Type: string.
     * @param {dashboardSettigsSocialNetworkDisconnectSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsSocialNetworkDisconnectSuccess = function (params) {
        return this.bi.log(__assign({ evid: 177 }, params));
    };
    /**
    * @typedef {Object} revisionsRestoreSuccessStayInPageParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) restore success stay in page. Evid: 257.
    
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsRestoreSuccessStayInPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsRestoreSuccessStayInPage = function (params) {
        return this.bi.log(__assign({ evid: 257 }, params));
    };
    /**
    * @typedef {Object} myAccountCreateSiteParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> Create site. Evid: 70.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountCreateSiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountCreateSite = function (params) {
        return this.bi.log(__assign({ evid: 70 }, params));
    };
    /**
    * @typedef {Object} myAccountUserClicksOnUpgradeButtonInsideTheIframeOfEachAppParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> user clicks on upgrade button inside the iframe of each app. Evid: 134.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUserClicksOnUpgradeButtonInsideTheIframeOfEachAppParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUserClicksOnUpgradeButtonInsideTheIframeOfEachApp = function (params) {
        return this.bi.log(__assign({ evid: 134 }, params));
    };
    /**
    * @typedef {Object} myAccountConnectYourDomainFirstPageParams
    
    **/
    /**
     * Name: my account -> connect your domain first page. Evid: 126.
    
    
    
     * @param {myAccountConnectYourDomainFirstPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountConnectYourDomainFirstPage = function (params) {
        return this.bi.log(__assign({ evid: 126 }, params));
    };
    /**
    * @typedef {Object} siteMembersSiteMembersSectionClickedParams
    
    **/
    /**
     * Name: (site members) site members section clicked. Evid: 205.
    
    
    
     * @param {siteMembersSiteMembersSectionClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersSiteMembersSectionClicked = function (params) {
        return this.bi.log(__assign({ evid: 205 }, params));
    };
    /**
    * @typedef {Object} revisionsReportPagePerformanceParams
    * @property {number} clientProcessTime - DOM processing time (clientPageProcessingTime)
    * @property {GUID} i1 - msid
    * @property {number} c2 - referrer
    * @property {number} g1 - revision
    * @property {number} serverLoadTime - server load time
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - site id
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) report page performance. Evid: 270.
     * Event description: this event reports *when possible* the time load of server & client.
    server time + client time will represent entire page load time.
    
     * clientProcessTime - Type: numeric. Desc: DOM processing time (clientPageProcessingTime)
     *
     * i1 - Type: guid. Desc: msid
     *
     * c2 - Type: numeric. Desc: referrer
     *
     * g1 - Type: numeric. Desc: revision
     *
     * serverLoadTime - Type: numeric. Desc: server load time
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid. Desc: site id
     *
     * version - Type: string. Desc: version
     * @param {revisionsReportPagePerformanceParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsReportPagePerformance = function (params) {
        return this.bi.log(__assign({ evid: 270 }, params));
    };
    /**
    * @typedef {Object} revisionsCloseRevisionsFrameParams
    * @property {GUID} c1 - null
    * @property {string} g1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) close revisions frame. Evid: 261.
    
    
     * c1 - Type: guid.
     *
     * g1 - Type: string.
     *
     * version - Type: string. Desc: version
     * @param {revisionsCloseRevisionsFrameParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsCloseRevisionsFrame = function (params) {
        return this.bi.log(__assign({ evid: 261 }, params));
    };
    /**
    * @typedef {Object} manageEtpaUserClicksBackToTopParams
    * @property {GUID} g1 -  etpa id
    * @property {GUID} c1 - null
    **/
    /**
     * Name: (manage etpa) user clicks back to top. Evid: 152.
    
    
     * g1 - Type: guid. Desc:  etpa id
     *
     * c1 - Type: guid.
     * @param {manageEtpaUserClicksBackToTopParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageEtpaUserClicksBackToTop = function (params) {
        return this.bi.log(__assign({ evid: 152 }, params));
    };
    /**
    * @typedef {Object} revisionsFilterAllRevisionsEvent269IsReplacingThisEventParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {number} g1 - null
    * @property {GUID} c1 - null
    **/
    /**
     * Name: (revisions) filter all revisions - event 269 is replacing this event. Evid: 259.
    
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * g1 - Type: numeric.
     *
     * c1 - Type: guid.
     * @param {revisionsFilterAllRevisionsEvent269IsReplacingThisEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsFilterAllRevisionsEvent269IsReplacingThisEvent = function (params) {
        return this.bi.log(__assign({ evid: 259 }, params));
    };
    /**
    * @typedef {Object} revisionsPageCompleteLoadParams
    * @property {number} adiRevisions - how many ADI revisions loaded
    * @property {number} editorRevisions - how many editor revisions loaded
    * @property {number} loadTime - how long the page was loading
    * @property {GUID} i1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {number} g1 - revisionsAJAXLoadTime
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) page complete load. Evid: 251.
     * Event description: when the site history page is loaded.
    
     * adiRevisions - Type: numeric. Desc: how many ADI revisions loaded
     *
     * editorRevisions - Type: numeric. Desc: how many editor revisions loaded
     *
     * loadTime - Type: numeric. Desc: how long the page was loading
     *
     * i1 - Type: guid.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * g1 - Type: numeric. Desc: revisionsAJAXLoadTime
     *
     * version - Type: string. Desc: version
     * @param {revisionsPageCompleteLoadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsPageCompleteLoad = function (params) {
        return this.bi.log(__assign({ evid: 251 }, params));
    };
    /**
    * @typedef {Object} myAccountManageAndEditMetasiteParams
    * @property {GUID} c1 - null
    **/
    /**
     * Name: my account -> manage and edit metasite. Evid: 88.
    
    
     * c1 - Type: guid.
     * @param {myAccountManageAndEditMetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountManageAndEditMetasite = function (params) {
        return this.bi.log(__assign({ evid: 88 }, params));
    };
    /**
    * @typedef {Object} dashboardMainPageSideBannerParams
    
    **/
    /**
     * Name: dashboard -> main page side banner. Evid: 164.
    
    
    
     * @param {dashboardMainPageSideBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardMainPageSideBanner = function (params) {
        return this.bi.log(__assign({ evid: 164 }, params));
    };
    /**
    * @typedef {Object} manageEtpaUserClicksDeleteButton153Params
    * @property {GUID} g1 -  etpa id
    * @property {GUID} c1 - null
    **/
    /**
     * Name: (manage etpa) user clicks delete button. Evid: 153.
    
    
     * g1 - Type: guid. Desc:  etpa id
     *
     * c1 - Type: guid.
     * @param {manageEtpaUserClicksDeleteButton153Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageEtpaUserClicksDeleteButton153 = function (params) {
        return this.bi.log(__assign({ evid: 153 }, params));
    };
    /**
    * @typedef {Object} revisionsRestoreFailedParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {string} revision_builder - adi, editor
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {boolean} switch_builder - true if restoring to a different builder
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) restore failed. Evid: 258.
     * Event description: restoring to a revision failed.
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * revision_builder - Type: string. Desc: adi, editor
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * switch_builder - Type: bool. Desc: true if restoring to a different builder
     *
     * version - Type: string. Desc: version
     * @param {revisionsRestoreFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsRestoreFailed = function (params) {
        return this.bi.log(__assign({ evid: 258 }, params));
    };
    /**
    * @typedef {Object} myAccountSelectSiteFromSiteListPopupParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> select site from site-list popup. Evid: 129.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountSelectSiteFromSiteListPopupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountSelectSiteFromSiteListPopup = function (params) {
        return this.bi.log(__assign({ evid: 129 }, params));
    };
    /**
    * @typedef {Object} myAccountSeoButtonParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: (my account) SEO button. Evid: 147.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountSeoButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountSeoButton = function (params) {
        return this.bi.log(__assign({ evid: 147 }, params));
    };
    /**
    * @typedef {Object} manageEtpaUserClicksDeleteButton158Params
    * @property {GUID} g1 -  etpa id
    * @property {GUID} c1 - null
    **/
    /**
     * Name: (manage etpa) user clicks delete button. Evid: 158.
    
    
     * g1 - Type: guid. Desc:  etpa id
     *
     * c1 - Type: guid.
     * @param {manageEtpaUserClicksDeleteButton158Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.manageEtpaUserClicksDeleteButton158 = function (params) {
        return this.bi.log(__assign({ evid: 158 }, params));
    };
    /**
    * @typedef {Object} siteMembersDialogOpenedParams
    
    **/
    /**
     * Name: (site members) dialog opened. Evid: 200.
    
    
    
     * @param {siteMembersDialogOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersDialogOpened = function (params) {
        return this.bi.log(__assign({ evid: 200 }, params));
    };
    /**
    * @typedef {Object} myAccountUserClicksOnSidebarLinksParams
    * @property {string} g1 - null
    * @property {GUID} c1 - null
    **/
    /**
     * Name: (my account) user clicks on sidebar links. Evid: 154.
    
    
     * g1 - Type: string.
     *
     * c1 - Type: guid.
     * @param {myAccountUserClicksOnSidebarLinksParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUserClicksOnSidebarLinks = function (params) {
        return this.bi.log(__assign({ evid: 154 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsSocialNetworkConnectClickedParams
    * @property {string} c1 - null
    **/
    /**
     * Name: dashboard settigs -> social_network_connect_clicked. Evid: 170.
    
    
     * c1 - Type: string.
     * @param {dashboardSettigsSocialNetworkConnectClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsSocialNetworkConnectClicked = function (params) {
        return this.bi.log(__assign({ evid: 170 }, params));
    };
    /**
    * @typedef {Object} dashboardEcommerceBannerParams
    * @property {string} c1 - null
    **/
    /**
     * Name: dashboard -> ecommerce banner. Evid: 165.
    
    
     * c1 - Type: string.
     * @param {dashboardEcommerceBannerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardEcommerceBanner = function (params) {
        return this.bi.log(__assign({ evid: 165 }, params));
    };
    /**
    * @typedef {Object} revisionsRestorePopupConfirmParams
    * @property {GUID} i1 - null
    * @property {string} popup_type - adi to editor, editor to adi, regular restore
    * @property {number} c2 - null
    * @property {string} revision_builder - adi, editor
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) restore popup confirm. Evid: 255.
    
    
     * i1 - Type: guid.
     *
     * popup_type - Type: string. Desc: adi to editor, editor to adi, regular restore
     *
     * c2 - Type: numeric.
     *
     * revision_builder - Type: string. Desc: adi, editor
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsRestorePopupConfirmParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsRestorePopupConfirm = function (params) {
        return this.bi.log(__assign({ evid: 255 }, params));
    };
    /**
    * @typedef {Object} myAccountShowListViewParams
    
    **/
    /**
     * Name: my account -> Show list view. Evid: 67.
    
    
    
     * @param {myAccountShowListViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountShowListView = function (params) {
        return this.bi.log(__assign({ evid: 67 }, params));
    };
    /**
    * @typedef {Object} revisionsRenameRevisionParams
    * @property {GUID} i1 - msid
    * @property {number} c2 - referrer
    * @property {DateTime} revisionDateCreated - revision creation datetime
    * @property {number} g1 - revision
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - site id
    * @property {string} version - app version
    **/
    /**
     * Name: (revisions) rename revision. Evid: 266.
     * Event description: rename a revision.
    
     * i1 - Type: guid. Desc: msid
     *
     * c2 - Type: numeric. Desc: referrer
     *
     * revisionDateCreated - Type: datetime. Desc: revision creation datetime
     *
     * g1 - Type: numeric. Desc: revision
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid. Desc: site id
     *
     * version - Type: string. Desc: app version
     * @param {revisionsRenameRevisionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsRenameRevision = function (params) {
        return this.bi.log(__assign({ evid: 266 }, params));
    };
    /**
    * @typedef {Object} myAccountUpgradeMetasiteFirstPageParams
    
    **/
    /**
     * Name: my account -> upgrade metasite first page. Evid: 130.
    
    
    
     * @param {myAccountUpgradeMetasiteFirstPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUpgradeMetasiteFirstPage = function (params) {
        return this.bi.log(__assign({ evid: 130 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsSocialNetworkAuthSuccessParams
    * @property {boolean} interactive - null
    * @property {string} c1 - null
    **/
    /**
     * Name: dashboard settigs -> social_network_auth_success. Evid: 173.
    
    
     * interactive - Type: bool.
     *
     * c1 - Type: string.
     * @param {dashboardSettigsSocialNetworkAuthSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsSocialNetworkAuthSuccess = function (params) {
        return this.bi.log(__assign({ evid: 173 }, params));
    };
    /**
    * @typedef {Object} dashboardLoadingPhase1MetasiteParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: dashboard loading phase1 - metasite. Evid: 146.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {dashboardLoadingPhase1MetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardLoadingPhase1Metasite = function (params) {
        return this.bi.log(__assign({ evid: 146 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsSocialNetworkAuthFailedParams
    * @property {string} c1 - null
    * @property {string} reason - null
    **/
    /**
     * Name: dashboard settigs -> social_network_auth_failed. Evid: 172.
    
    
     * c1 - Type: string.
     *
     * reason - Type: string.
     * @param {dashboardSettigsSocialNetworkAuthFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsSocialNetworkAuthFailed = function (params) {
        return this.bi.log(__assign({ evid: 172 }, params));
    };
    /**
    * @typedef {Object} myAccountUserChangedPageParams
    * @property {GUID} etpaId - null
    * @property {GUID} metaSiteId - null
    * @property {string} i1 - null
    **/
    /**
     * Name: (my account) user changed page. Evid: 156.
    
    
     * etpaId - Type: guid.
     *
     * metaSiteId - Type: guid.
     *
     * i1 - Type: string.
     * @param {myAccountUserChangedPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUserChangedPage = function (params) {
        return this.bi.log(__assign({ evid: 156 }, params));
    };
    /**
    * @typedef {Object} myAccountSiteHistoryOnSidebarParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: (my account) Site history on sidebar. Evid: 148.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountSiteHistoryOnSidebarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountSiteHistoryOnSidebar = function (params) {
        return this.bi.log(__assign({ evid: 148 }, params));
    };
    /**
    * @typedef {Object} myAccountPersonalizedUpgradeButtonPerMetasiteParams
    * @property {string} g1 - null
    * @property {number} i1 - null
    * @property {GUID} c1 - null
    **/
    /**
     * Name: my account -> personalized upgrade button per metasite. Evid: 82.
    
    
     * g1 - Type: string.
     *
     * i1 - Type: numeric.
     *
     * c1 - Type: guid.
     * @param {myAccountPersonalizedUpgradeButtonPerMetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountPersonalizedUpgradeButtonPerMetasite = function (params) {
        return this.bi.log(__assign({ evid: 82 }, params));
    };
    /**
    * @typedef {Object} revisionsMinimizeSidebarParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {number} g1 - null
    * @property {string} sessionId - session id generated when the page starts loading
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) minimize sidebar. Evid: 263.
    
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * g1 - Type: numeric.
     *
     * sessionId - Type: string. Desc: session id generated when the page starts loading
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsMinimizeSidebarParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsMinimizeSidebar = function (params) {
        return this.bi.log(__assign({ evid: 263 }, params));
    };
    /**
    * @typedef {Object} dashboardGetGoogleAppsParams
    * @property {string} c1 - null
    **/
    /**
     * Name: dashboard -> get google apps. Evid: 162.
    
    
     * c1 - Type: string.
     * @param {dashboardGetGoogleAppsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardGetGoogleApps = function (params) {
        return this.bi.log(__assign({ evid: 162 }, params));
    };
    /**
    * @typedef {Object} myAccountUserClicksToAddAnAppOnTheAppListParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> user clicks to add an app on the app list. Evid: 131.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUserClicksToAddAnAppOnTheAppListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUserClicksToAddAnAppOnTheAppList = function (params) {
        return this.bi.log(__assign({ evid: 131 }, params));
    };
    /**
    * @typedef {Object} myAccountUpgradeButtonClickedOnMainPageOnSingleMetasiteParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> upgrade button clicked on main page on single metasite. Evid: 121.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUpgradeButtonClickedOnMainPageOnSingleMetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUpgradeButtonClickedOnMainPageOnSingleMetasite = function (params) {
        return this.bi.log(__assign({ evid: 121 }, params));
    };
    /**
    * @typedef {Object} myAccountUserClicksOnInstalledAppOnTheAppListParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> user clicks on installed app on the app list. Evid: 133.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUserClicksOnInstalledAppOnTheAppListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUserClicksOnInstalledAppOnTheAppList = function (params) {
        return this.bi.log(__assign({ evid: 133 }, params));
    };
    /**
    * @typedef {Object} duplicateDialogCancelParams
    
    **/
    /**
     * Name: duplicate dialog -> cancel. Evid: 159.
    
    
    
     * @param {duplicateDialogCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.duplicateDialogCancel = function (params) {
        return this.bi.log(__assign({ evid: 159 }, params));
    };
    /**
    * @typedef {Object} revisionsClickHelpButtonParams
    * @property {GUID} i1 - null
    * @property {number} c2 - null
    * @property {number} g1 - null
    * @property {GUID} c1 - null
    * @property {string} version - version
    **/
    /**
     * Name: (revisions) click help button. Evid: 262.
    
    
     * i1 - Type: guid.
     *
     * c2 - Type: numeric.
     *
     * g1 - Type: numeric.
     *
     * c1 - Type: guid.
     *
     * version - Type: string. Desc: version
     * @param {revisionsClickHelpButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.revisionsClickHelpButton = function (params) {
        return this.bi.log(__assign({ evid: 262 }, params));
    };
    /**
    * @typedef {Object} siteMembersSettingsTabClickedParams
    
    **/
    /**
     * Name: (site members) settings tab clicked. Evid: 204.
    
    
    
     * @param {siteMembersSettingsTabClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersSettingsTabClicked = function (params) {
        return this.bi.log(__assign({ evid: 204 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnManagePremiumButtonsParams
    * @property {string} c1 -  The sub-category of manage account
    **/
    /**
     * Name: my account -> click on manage premium buttons. Evid: 85.
    
    
     * c1 - Type: string. Desc:  The sub-category of manage account
     * @param {myAccountClickOnManagePremiumButtonsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnManagePremiumButtons = function (params) {
        return this.bi.log(__assign({ evid: 85 }, params));
    };
    /**
    * @typedef {Object} siteMembersHelpCenterClickedParams
    
    **/
    /**
     * Name: (site members) help center clicked. Evid: 207.
    
    
    
     * @param {siteMembersHelpCenterClickedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersHelpCenterClicked = function (params) {
        return this.bi.log(__assign({ evid: 207 }, params));
    };
    /**
    * @typedef {Object} myAccountTransferCompletedParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> transfer completed. Evid: 96.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountTransferCompletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountTransferCompleted = function (params) {
        return this.bi.log(__assign({ evid: 96 }, params));
    };
    /**
    * @typedef {Object} dashboardSettigsListSocialConnectionsSuccessParams
    
    **/
    /**
     * Name: dashboard settigs -> list_social_connections_success. Evid: 169.
    
    
    
     * @param {dashboardSettigsListSocialConnectionsSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dashboardSettigsListSocialConnectionsSuccess = function (params) {
        return this.bi.log(__assign({ evid: 169 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnViewHistoryParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> click on view history. Evid: 136.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountClickOnViewHistoryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnViewHistory = function (params) {
        return this.bi.log(__assign({ evid: 136 }, params));
    };
    /**
    * @typedef {Object} myAccountOpeningOnlineStoreManagerParams
    * @property {GUID} c1 - null
    **/
    /**
     * Name: my account -> opening online store manager. Evid: 86.
    
    
     * c1 - Type: guid.
     * @param {myAccountOpeningOnlineStoreManagerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountOpeningOnlineStoreManager = function (params) {
        return this.bi.log(__assign({ evid: 86 }, params));
    };
    /**
    * @typedef {Object} myAccountClickOnViewMobileSiteParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> click on 'view mobile site'. Evid: 140.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountClickOnViewMobileSiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountClickOnViewMobileSite = function (params) {
        return this.bi.log(__assign({ evid: 140 }, params));
    };
    /**
    * @typedef {Object} myAccountShowGridViewParams
    
    **/
    /**
     * Name: my account -> Show grid view. Evid: 68.
    
    
    
     * @param {myAccountShowGridViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountShowGridView = function (params) {
        return this.bi.log(__assign({ evid: 68 }, params));
    };
    /**
    * @typedef {Object} myAccountUpgradeBannerPerMetasiteParams
    * @property {GUID} c1 - null
    * @property {number} i1 - null
    **/
    /**
     * Name: my account -> Upgrade banner per metasite. Evid: 120.
    
    
     * c1 - Type: guid.
     *
     * i1 - Type: numeric.
     * @param {myAccountUpgradeBannerPerMetasiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.myAccountUpgradeBannerPerMetasite = function (params) {
        return this.bi.log(__assign({ evid: 120 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 2,
        endpoint: 'hap'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map